export default __webpack_public_path__ + "images/add-to-cart.0bc245212fadcb1c7547b5465f378977.svg";